<template>
  <div v-if="convertedColumnWithSearch.length">
    <Kanban :loading="loadingKanban" class="order-kanban">
      <OrderKanbanColumn
        v-for="(column, index) in convertedColumnWithSearch"
        :key="index"
        :column="column"
        :search-result="searchResult"
        @refresh="refreshColumn"
        @open-nested="openNestedColumns"
        @search="searchColumn"
        @searchAll="searchAllColumns"
        @intersect="pagination"
        @click-item="openOrder"
        @moved="moved"
      />
      <router-view></router-view>
      <OrderCreateModal
        :reference_status_id="539"
        @created-order="unshiftNewOrder"
      />
    </Kanban>
  </div>
  <div v-else-if="convertedColumnWithSearch.length === 0 && !searchResult" style="transform: translateY(300%);">
    <div class="text-center text-success my-5">
      <b-spinner variant="success"></b-spinner>
    </div>
    <div class="text-center">Ожидайте...</div>
  </div>
  <h6 v-else-if="convertedColumnWithSearch.length === 0 && searchResult" class="text-uppercase" style="margin-top: 14px;">Ничего не найдено. Попробуйте ввести другой запрос.</h6>
</template>

<script>
import { mapGetters } from "vuex";
import debounce from "@/services/helpers";
import { API_ORDERS, API_ORDERS_KANBAN } from "@/constants/api";
import Kanban from "@components/ui/Kanban/Kanban";
import OrderKanbanColumn from "@components/orderKanban/OrderKanbanColumn";
import OrderCreateModal from "@components/orders/OrderCreateModal";

export default {
  components: {
    Kanban,
    OrderKanbanColumn,
    OrderCreateModal,
  },

  metaInfo() {
    return {
      title: "Запросы",
    };
  },

  props: {
    searchResult: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      columns: [],
      ordersMoving: false,
      loadingKanban: true,
    };
  },

  computed: {
    ...mapGetters("orderDetail", [
      "orderWidgetValue",
      "orderWidgetStatus",
      "orderChangedColumns",
    ]),

    kanbanType() {
      return this.$route.query.kanban_type || "sales";
    },

    convertedColumn() {
      return this.columns.reduce((acc, element, index, array) => {
        if (element.kanban_meta.parent_column) {
          element.nested_columns = array.filter(
            (nested) =>
              nested.kanban_meta.reference_status_id ===
                element.kanban_meta.reference_status_id &&
              nested.kanban_meta.parent_column === false
          );
          acc.push(element);
        }
        return acc;
      }, []);
    },
    convertedColumnWithSearch() {
      if (this.searchResult) {
        return this.filterEmptyItems()
      }
      return this.convertedColumn
    }
  },

  watch: {
    "$route.query.kanban_type"() {
      this.loadingKanban = true;
      this.initKanban();
    },

    orderChangedColumns(value) {
      value.forEach((id) => {
        this.columns.forEach((column) => {
          if (id === column.kanban_meta.reference_status_id) {
            setTimeout(() => {
              this.refreshColumn(column);
            }, 1000);
          }
        });
      });
    },

    orderWidgetValue(value) {
      this.columns.forEach((column) => {
        if (
          column.kanban_meta.reference_status_id === value.reference_status_id
        ) {
          column.items.forEach((item) => {
            if (item.id === value.id) {
              item = Object.assign(item, value);
            }
          });
        }
      });
    },

    searchResult() {
      if (this.searchResult === '') {
        this.initKanban();
      }
    }
  },

  methods: {
    unshiftNewOrder(order) {
      let sales_manager_id =
        order.optional_sales_manager && order.optional_sales_manager.id;
      this.columns.forEach((el) => {
        if (
          el.kanban_meta.reference_status_id === order.reference_status_id &&
          el.kanban_meta.user_id === sales_manager_id
        ) {
          el.items.unshift(order);
          el.meta.total++;
        }
      });
    },

    searchColumn: debounce(async function (column) {
      column.loading_status = true;
      const { meta, items } = await this.fetchOrder(
        column.kanban_meta,
        column.search
      );
      column.loading_status = false;
      column.items = items;
      column.meta = !!column.search ? column.meta : meta;
      column.search_meta = !!column.search ? meta : {};
    }, 1000),

    async searchAllColumns(column) {
      if (column !== null && column !== undefined) {
        column.loading_status = true;
        const { meta, items } = await this.fetchOrder(
          column.kanban_meta,
          column.search
        );
        column.loading_status = false;
        column.items = items;
        column.meta = !!column.search ? column.meta : meta;
        column.search_meta = !!column.search ? meta : {};
      }
    },

    async fetchOrder(params, search) {
      return await axios
        .get(API_ORDERS, { params: { ...params, q: search } })
        .then(({ data }) => {
          return {
            items: data.data,
            loading_sales_manager: false,
            meta: {
              total_services: data.total_services,
              to: data.to,
              total: data.total,
              per_page: data.per_page,
              page: data.current_page,
            },
          };
        });
    },

    fetchAll(arr) {
      arr.forEach((el) => {
        this.refreshColumn(el);
      });
    },

    async refreshColumn(column) {
      const metaColumn = !!column.search ? "search_meta" : "meta";
      column.loading_status = true;
      const { items, meta } = await this.fetchOrder(
        column.kanban_meta,
        column.search
      );
      column.loading_status = false;
      column.items = items;
      column[metaColumn] = meta;
    },

    async pagination(column) {
      const { items, meta } = await this.fetchOrder({
        ...column.kanban_meta,
        page: ++column.meta.page,
        per_page: column.meta.per_page,
      });

      const s = new Set(column.items.map((el) => el.id));
      column.items.push(...items.filter((e) => !s.has(e.id)));
      column.meta = meta;
    },

    observerView(column) {
      const meta = !!column.search ? "search_meta" : "meta";
      if (!!column[meta].to === false) {
        return false;
      } else {
        return column[meta].to !== column[meta].total;
      }
    },

    openNestedColumns(column) {
      column.kanban_meta.all_users_opened =
        !column.kanban_meta.all_users_opened;
    },

    moved(e) {
      // Проверяем, не заблокирована ли колонка для drag
      if (e.removed && e.column.kanban_meta.disable_drag) {
        // Если пытаются вытащить из заблокированной колонки, отменяем действие
        console.warn('Перемещение из колонки заблокировано:', e.column.kanban_meta.reference_status_name);
        this.$bvToast.toast('Перемещение из этой колонки недоступно', {
          title: 'Внимание',
          variant: 'warning',
          solid: true,
          autoHideDelay: 3000
        });
        return;
      }

      if (e.added) {
        this.ordersMoving = true;
        ++e.column.meta.total;
        ++e.column.meta.to;

        axios
          .put(`${API_ORDERS}/${e.added.element.id}`, {
            reference_status_id: e.column.kanban_meta.reference_status_id,
            optional_sales_manager_user_id: e.column.kanban_meta.user_id,
            kanban_type: e.column.kanban_meta.kanban_type,
          })
          .then(({ data }) => {
            this.ordersMoving = false;
            if (e.column.kanban_meta.user_id) {
              Object.assign(e.column.items[e.added.newIndex], data);
            }
          });
      }

      if (e.removed) {
        --e.column.meta.total;
        --e.column.meta.to;
        --e.column.meta.per_page;
      }
    },

    openOrder(id) {
      this.$router.push({
        path: `${this.$route.path}?kanban_type=${this.kanbanType}`,
        query: { 
          ...this.$route.query,
          order: id 
        },
      });
      setTimeout(() => {
        this.$root.$emit('bv::toggle::collapse', 'sidebar-right-order');
      }, 0)
    },

    async initKanban() {
      const { data } = await axios.get(API_ORDERS_KANBAN, {
        params: {
          kanban_type: this.kanbanType,
        },
      });
      this.loadingKanban = false;
      this.columns = data.map((el) => {
        return {
          kanban_meta: el,
          items: [],
          meta: [],
          search_meta: {},
          nested_columns: [],
          loading_status: true,
          search: "",
        };
      });
      this.fetchAll(this.columns);
    },

    filterEmptyItems() {
      let copyOfColumns = this.convertedColumn.slice();

      for (let i = 0; i < copyOfColumns.length; i++) {
        copyOfColumns[i].nested_columns = copyOfColumns[i].nested_columns.filter(item => item.items.length !== 0);
      }

      copyOfColumns = copyOfColumns.filter(column => column.items.length !== 0 || column.nested_columns.length !== 0);

      return copyOfColumns
    }
  },

  mounted() {
    this.initKanban();
  },
};
</script>

<style lang="scss" scoped src="~/components/orderKanban/OrderKanban.scss" />
